import { OrganizationInfo } from "@models/organization.model"
import { ProductsInfo } from "@models/products.model"
import { ProjectInfo } from "@models/projects.model"
import { createContext, ReactNode, useReducer } from "react"
import ConfigurationWrapper from "./ConfigurationsWrapper"
import OptionReducer, { ActionType } from "./reducer"

export interface OptionsProps {
  projectList?: ProjectInfo[]
  organazationList?: OrganizationInfo[]
  productsList?: ProductsInfo[]
}

const initialGlobalState: any = {}

export const ConfigurationContext = createContext<{
    state: OptionsProps
    dispatch: React.Dispatch<ActionType>
  }>({
    state: initialGlobalState,
    dispatch: () => undefined,
  })

interface Props {
    children?: ReactNode
}

export const ConfigurationProvider = ({ children, ...props }: Props)  => {
    const [state, dispatch] = useReducer(OptionReducer, initialGlobalState)

    return (
        <ConfigurationContext.Provider
          value={{ state, dispatch }}>
            <ConfigurationWrapper>{children}</ConfigurationWrapper>
        </ConfigurationContext.Provider>
      )
}
